import { retryTransient } from '@agos/api-client'
import { useGetMiniGameStatus } from '@agos/api-client/marketing'
import { useCustomerAuth } from '@agos/customer-core'
import { useMemo } from 'react'

import { MiniGameCards } from './MiniGameCards'
import { runningGames, statusOf } from './minigame'

/**
 * *Klikni a vyhraj* and *Stierací los* under *Ďakujeme!* - `FRONTEND.md` §9.779, owner O138f.
 *
 * *"pod tým by sa zobrazili tieto kampane ... len pre registrovaných zákazníkov"*. The profile's own game,
 * played in a second place: the server draws, awards and counts the day's plays as it does there, so an order
 * is not a second play.
 *
 * **A guest sees nothing**, and neither does a customer whose status read failed: nothing a guest may read
 * says whether a game runs, so an invitation could promise one that is switched off, and a thank-you page is
 * not the place for a sentence about a read the customer did not ask for. The success page draws this only
 * for an order the tab has just placed.
 */
export function OrderPlacedGames() {
  const signedIn = useCustomerAuth((state) => state.user) !== null
  const games = useGetMiniGameStatus({ query: { enabled: signedIn, retry: retryTransient } })
  const running = useMemo(() => runningGames(statusOf(games.data)), [games.data])

  if (!signedIn || games.data === undefined) return null
  return <MiniGameCards games={running} onPlayed={() => games.refetch()} onlyPlayable />
}
